module.exports = __webpack_public_path__ + "static/banner-c9e577a734d42b91504c3343a1432277.jpg";